import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy } from 'react';

const LazyVkAuth = lazy(() =>
  import('./VkAuth')
    .then((module) => ({ default: module.VkAuth }))
    .catch(() => {
      document.location.reload();
      return { default: () => <></> };
    })
);

export const VkAuth = ({ onLogin }: { onLogin: () => void }): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyVkAuth onLogin={onLogin} />
  </Suspense>
);
